/**
 *
 * DivisionEdit
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { pick } from "lodash"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import DivisionEditTemplate from "components/DivisionEditTemplate"
import Loader from "components/Loader"
import reducer from "./reducer"
import saga from "./saga"

import {
  makeSelectIsLoadingDivision,
  makeSelectDivision,
  makeSelectDivisionParents,
  makeSelectIsLoadingDivisionParents,
  makeSelectIsLoadingSubdivisionsWithoutParents,
  makeSelectSubivisionsWithoutParents,
  makeSelectIsLoadingChildrenDivision,
  makeSelectChildrenDivision,
  makeSelectCollaboratorsDivision,
  makeSelectMessageErrorUpdateName,
  makeSelectMessageDeleteSubdivision,
  makeSelectListDivisions,
  makeSelectListEmployees,
  makeSelectIsLoadingHistory,
  makeSelectHistory,
  makeSelectIsLoadingLanguage,
  makeSelectLanguage,
} from "./selectors"
import {
  getEmployeesDivisionsWatcher,
  getDivisionWatcher,
  getChildrenDivisionWatcher,
  getDivisionParentsWatcher,
  getSubdivisionsWithoutParentWatcher,
  deleteDivisionWatcher,
  addSubdivisionWatcher,
  deleteSubdivisionWatcher,
  updateNameDivisionWatcher,
  changeSelectSuperiorWatcher,
  upLevelOneWatcher,
  getCollaboratorsDivisionWatcher,
  getHistoryWatcher,
  getLanguageWatcher,
} from "./actions"

/* eslint-disable react/prefer-stateless-function */
export class DivisionEdit extends React.Component {
  componentDidMount = () => {
    const {
      match: {
        params: { id },
      },
    } = this.props
    this.props.getDetails(id)
    this.props.getDivision(id)
    this.props.getDivisionParents(id)
    this.props.getChildrenDivision(id)
    this.props.getSubdivisionsWithoutParent(id)
    this.props.getCollaboratorsDivision(id)
    this.props.getHistoryWatcher(id)
  }

  render() {
    const { isLoadingDivision, isLoadingDivisionParents } = this.props

    return (
      <React.Fragment>
        <Helmet>
          <title>Organización - Divisiones</title>
          <meta name="description" content="Description of DivisionEdit" />
        </Helmet>
        {isLoadingDivision || isLoadingDivisionParents ? (
          <Loader />
        ) : (
          <DivisionEditTemplate
            {...pick(this.props, [
              "division",
              "childrenDivision",
              "divisionParents",
              "subdivisionsWithoutParent",
              "deleteDivision",
              "addSubdivision",
              "getDivision",
              "isLoadingChildrenDivision",
              "deleteSubdivision",
              "updateNameDivision",
              "changeSelectSuperior",
              "upLevelOne",
              "collaboratorsDivision",
              "history",
              "messageDeleteSubdivision",
              "list_employees",
              "dataHistory",
              "isLoadingLanguage",
              "languages",
              "getLanguage",
            ])}
          />
        )}
      </React.Fragment>
    )
  }
}

DivisionEdit.propTypes = { getDivision: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  isLoadingDivision: makeSelectIsLoadingDivision(),
  division: makeSelectDivision(),
  isLoadingDivisionParents: makeSelectIsLoadingDivisionParents(),
  divisionParents: makeSelectDivisionParents(),
  isLoadingSubdivisionsWithoutParent: makeSelectIsLoadingSubdivisionsWithoutParents(),
  subdivisionsWithoutParent: makeSelectSubivisionsWithoutParents(),
  isLoadingChildrenDivision: makeSelectIsLoadingChildrenDivision(),
  childrenDivision: makeSelectChildrenDivision(),
  collaboratorsDivision: makeSelectCollaboratorsDivision(),
  messageErrorUpdateName: makeSelectMessageErrorUpdateName(),
  messageDeleteSubdivision: makeSelectMessageDeleteSubdivision(),
  list_employees: makeSelectListEmployees(),
  list_divisions: makeSelectListDivisions(),
  isLoadingHistory: makeSelectIsLoadingHistory(),
  dataHistory: makeSelectHistory(),
  isLoadingLanguage: makeSelectIsLoadingLanguage(),
  languages: makeSelectLanguage(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDetails: (params) => dispatch(getEmployeesDivisionsWatcher(params)),
    getDivision: (params) => dispatch(getDivisionWatcher(params)),
    getChildrenDivision: (params) =>
      dispatch(getChildrenDivisionWatcher(params)),
    getDivisionParents: (params) => dispatch(getDivisionParentsWatcher(params)),
    getSubdivisionsWithoutParent: (params) =>
      dispatch(getSubdivisionsWithoutParentWatcher(params)),
    deleteDivision: (params) => dispatch(deleteDivisionWatcher(params)),
    addSubdivision: (params) => dispatch(addSubdivisionWatcher(params)),
    deleteSubdivision: (params) => dispatch(deleteSubdivisionWatcher(params)),
    updateNameDivision: (params) => dispatch(updateNameDivisionWatcher(params)),
    changeSelectSuperior: (params) =>
      dispatch(changeSelectSuperiorWatcher(params)),
    upLevelOne: (params) => dispatch(upLevelOneWatcher(params)),
    getHistoryWatcher: (params) => dispatch(getHistoryWatcher(params)),
    getCollaboratorsDivision: (params) =>
      dispatch(getCollaboratorsDivisionWatcher(params)),
    getLanguage: (params) => dispatch(getLanguageWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "divisionEdit", reducer })
const withSaga = injectSaga({ key: "divisionEdit", saga })

export default compose(withReducer, withSaga, withConnect)(DivisionEdit)
